<script>
import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import axios from 'axios'
import ModalMixin from '@/mixins/ModalMixin.js'
import {
  WindIcon,
  LogOutIcon,
  LogInIcon,
  XSquareIcon,
  HelpCircleIcon,
  XIcon
} from 'vue-feather-icons'

export default {
  components: {
    WindIcon,
    LogOutIcon,
    LogInIcon,
    XSquareIcon,
    HelpCircleIcon,
    XIcon
  },
  extends: BaseModal,
  mixins: [ModalMixin],
  data: function () {
    return {}
  },
  methods: {
    riseLockerIssue(message) {
      this.$blockUI()
      axios({
        method: 'put',
        url: `/boxes/${this.data.box.id}/broken`,
        headers: {
          common: {
            Authorization: `Bearer ${window.localStorage.getItem(
              'support_session_token'
            )}`
          }
        },
        params: {
          message
        }
      })
        .then((response) => {
          this.$success(this.$t('success.boxIssueReported'))
          this.close(true)
        })
        .catch((error) => {
          this.$errorHumanized(error)
        })
        .finally(() => {
          this.$unblockUI()
        })
    }
  }
}
</script>

<template lang="pug">
span
  .modal-header
    x-icon(size="1.5x" @click="close(false)")
  .modal-body
    h1.page__header {{ $t('support.collectomate.supportRaiseLockerIssueModal.header') }}
    h3.page__description.mb-5 {{ $t('support.collectomate.supportRaiseLockerIssueModal.subheader') }}
    .row
      .col-4
        button.btn.btn-outline-dark.btn-block.d-flex.justify-content-between.m-4(
          v-ea-click="() => {riseLockerIssue('dirty_locker')}"
        )
          span {{ $t('support.collectomate.supportRaiseLockerIssueModal.dirtyLockerButton') }}
          wind-icon(size="1.5x")
      .col-4
        button.btn.btn-outline-dark.btn-block.d-flex.justify-content-between.m-4(
          v-ea-click="() => {riseLockerIssue('cant_open')}"
        )
          span {{ $t('support.collectomate.supportRaiseLockerIssueModal.cantOpenButton') }}
          log-out-icon(size="1.5x")
      .col-4
        button.btn.btn-outline-dark.btn-block.d-flex.justify-content-between.m-4(
          v-ea-click="() => {riseLockerIssue('cant_close')}"
        )
          span {{ $t('support.collectomate.supportRaiseLockerIssueModal.cantCloseButton') }}
          log-in-icon(size="1.5x")
      .col-4
        button.btn.btn-outline-dark.btn-block.d-flex.justify-content-between.m-4(
          v-ea-click="() => {riseLockerIssue('locker_too_small')}"
        )
          span {{ $t('support.collectomate.supportRaiseLockerIssueModal.lockerTooSmallButton') }}
          x-square-icon(size="1.5x")
      .col-4
        button.btn.btn-outline-dark.btn-block.d-flex.justify-content-between.m-4(
          v-ea-click="() => {riseLockerIssue('other')}"
        )
          span {{ $t('support.collectomate.supportRaiseLockerIssueModal.otherButton') }}
          help-circle-icon(size="1.5x")
</template>
